export default "__VITE_ASSET__8ed9a914__"